import React from "react";
import "./TestingService.css";

const TestingService = () => {
  return (
    <div>
      {/* Top Hero Section with Flex Layout */}
     {/* 🧪 Top Hero Banner with Full-Width Image and Overlay Heading */}
<div className="hero-banner">
  {/* <img src="/testing4.jpg" alt="Testing and Certification" className="hero-bg-img" /> */}
  <div className="hero-overlay">
    <div className="hero-text">
      <h1>
        Testing & Certification<br />
        Services for Payment<br />
        Solutions
      </h1>
    </div>
  </div>
</div>


      {/* Middle Section */}
     {/* Middle Section */}
<div className="middle-section">
  <div className="content-wrapper">
    <p>
      TA’s testing and certification services support the quality,
      performance, finance industry regulatory compliance, validation
      testing and other requirements for payment solutions. We leverage
      our extensive knowledge of industry payment platforms, digital
      wallet solutions, ISO messaging protocols, PCI compliance mandates
      APIs & testing tools to help banks and Fintech companies accelerate
      the modernization of their payment platforms and deliver rapid time
      to value for their customers.
    </p>
    <p>
      We have developed our own suite of test cases for rigorous testing
      of payment applications and integration with payment processors
      like Visa, Mastercard & RuPay. This test suite has been battle
      tested in the deployment of large-scale wallet solutions for
      multiple customers and leverages industry domain knowledge and
      industry best practices.
    </p>
    <p>
      TA is also working very closely with industry ecosystem entities
      like National Payments Corporation of India (NPCI) and some of the
      leading banks of India for payment related process improvements,
      application testing, validation, and certification services.
    </p>
  </div>
</div>


      {/* Bottom CTA */}
      {/* Bottom CTA */}
<div className="bottom-cta">
  <div className="cta-container">
    <h3>
      Looking for domain expertise in Payment Solutions?
    </h3>
    <p>
      Accelerate Time-to-Market with our Certification Service.
    </p>
    <button>
      Schedule Demo Now →
    </button>
  </div>
</div>

    </div>
  );
};

export default TestingService;
